module.exports = __webpack_public_path__ + "img/fogg-logged-out-1.6ae68afc.svg";